/**
 * @generated SignedSource<<f23a4b159f525960b19023385b0c4682>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserType = "MEMBER" | "STAFF" | "WHOOSH_ADMIN";
export type CreateSessionInput = {
  allowMemberRedirect?: boolean | null | undefined;
  email: string;
  password: string;
};
export type useSignInMutation$variables = {
  input: CreateSessionInput;
};
export type useSignInMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly session: {
      readonly currentClientProfile: {
        readonly active?: boolean;
        readonly id?: string;
        readonly member: {
          readonly __typename: string;
          readonly club: {
            readonly id: string;
            readonly name: string;
          };
          readonly departmentMemberProfiles?: ReadonlyArray<{
            readonly department?: {
              readonly slug: string;
            } | null | undefined;
            readonly ghinNumber?: number | null | undefined;
          } | null | undefined> | null | undefined;
          readonly email?: string | null | undefined;
          readonly firstName?: string | null | undefined;
          readonly fullName?: string;
          readonly id?: string;
          readonly lastName?: string | null | undefined;
          readonly memberGroups?: ReadonlyArray<{
            readonly id: string;
          } | null | undefined> | null | undefined;
          readonly membershipType?: {
            readonly id: string;
          } | null | undefined;
          readonly phoneNumber?: {
            readonly nationalNumber: string;
          } | null | undefined;
          readonly profileImage?: {
            readonly publicId: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly masquerader: {
        readonly email: string | null | undefined;
        readonly username: string | null | undefined;
      } | null | undefined;
      readonly user: {
        readonly email: string | null | undefined;
        readonly id: string;
        readonly memberProfiles?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly member: {
                readonly club: {
                  readonly id: string;
                  readonly logoImage: {
                    readonly publicId: string;
                  } | null | undefined;
                  readonly name: string;
                  readonly slug: string;
                  readonly supportsPublic: boolean;
                };
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly metadata?: {
          readonly hasSeenNotificationNudgeModal: boolean | null | undefined;
        } | null | undefined;
        readonly username: string | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"useSyncAnalyticsTrackingPermission_session">;
    } | null | undefined;
    readonly success: boolean;
    readonly userType: UserType | null | undefined;
  } | null | undefined;
};
export type useSignInMutation = {
  response: useSignInMutation$data;
  variables: useSignInMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userType",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "GOLF"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ghinNumber",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "departmentMemberProfiles",
  "plural": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v8/*: any*/)
          ],
          "storageKey": null
        },
        (v9/*: any*/)
      ],
      "type": "GolfMemberProfile",
      "abstractKey": null
    }
  ],
  "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
},
v11 = [
  (v5/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "CustomerType",
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationalNumber",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumber",
  "plural": false,
  "selections": [
    (v17/*: any*/)
  ],
  "storageKey": null
},
v19 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "MembershipType",
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberGroup",
  "kind": "LinkedField",
  "name": "memberGroups",
  "plural": true,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    }
  ],
  "type": "MemberProfile",
  "abstractKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v25 = [
  {
    "kind": "Literal",
    "name": "active",
    "value": true
  }
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Club",
  "kind": "LinkedField",
  "name": "club",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v4/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsPublic",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": (v19/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSeenNotificationNudgeModal",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUnauthenticatedAnalyticsTracking",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiresAnalyticsTrackingConsent",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsTrackingConsentedAt",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultCountryCode",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v35 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v36 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "departmentMemberProfiles",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        (v9/*: any*/)
      ],
      "type": "GolfMemberProfile",
      "abstractKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumber",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSignInMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreateSessionPayload",
        "kind": "LinkedField",
        "name": "createSession",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentClientProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v12/*: any*/),
                          (v5/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/)
                        ],
                        "type": "Customer",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v5/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/)
                        ],
                        "type": "Member",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "masquerader",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v16/*: any*/),
                  (v24/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v25/*: any*/),
                        "concreteType": "MemberProfileConnection",
                        "kind": "LinkedField",
                        "name": "memberProfiles",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfileEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberProfile",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "member",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "memberProfiles(active:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MemberUser",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "useSyncAnalyticsTrackingPermission_session",
                "selections": [
                  (v28/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              (v30/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MemberUser",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "currentClientProfile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "member",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Club",
                            "kind": "LinkedField",
                            "name": "club",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSignInMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreateSessionPayload",
        "kind": "LinkedField",
        "name": "createSession",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/),
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v25/*: any*/),
                        "concreteType": "MemberProfileConnection",
                        "kind": "LinkedField",
                        "name": "memberProfiles",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfileEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberProfile",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "member",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v26/*: any*/),
                                      (v35/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "memberProfiles(active:true)"
                      }
                    ],
                    "type": "MemberUser",
                    "abstractKey": null
                  },
                  (v5/*: any*/),
                  (v16/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentClientProfile",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v5/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isClient"
                      },
                      (v35/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v36/*: any*/),
                          (v12/*: any*/),
                          (v5/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v37/*: any*/),
                          (v20/*: any*/)
                        ],
                        "type": "Customer",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v36/*: any*/),
                          (v5/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v37/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/)
                        ],
                        "type": "Member",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v35/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "masquerader",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v16/*: any*/),
                  (v24/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8ff3a1e7877e654d822c7160bf2b1a81",
    "id": null,
    "metadata": {},
    "name": "useSignInMutation",
    "operationKind": "mutation",
    "text": "mutation useSignInMutation(\n  $input: CreateSessionInput!\n) {\n  responsePayload: createSession(input: $input) {\n    userType\n    success\n    session {\n      ...useSyncAnalyticsTrackingPermission_session\n      currentClientProfile {\n        __typename\n        ... on MemberProfile {\n          id\n          active\n        }\n        member {\n          __typename\n          club {\n            name\n            id\n          }\n          __isClient: __typename\n          ... on Customer {\n            departmentMemberProfiles(type: GOLF) {\n              __typename\n              ... on GolfMemberProfile {\n                department {\n                  slug\n                  id\n                }\n                ghinNumber\n              }\n              id\n            }\n            membershipType {\n              id\n            }\n            __typename\n            id\n            firstName\n            lastName\n            fullName\n            email\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            profileImage {\n              publicId: renderingKey\n            }\n          }\n          ... on Member {\n            departmentMemberProfiles(type: GOLF) {\n              __typename\n              ... on GolfMemberProfile {\n                department {\n                  slug\n                  id\n                }\n                ghinNumber\n              }\n              id\n            }\n            __typename\n            id\n            firstName\n            lastName\n            fullName\n            email\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            profileImage {\n              publicId: renderingKey\n            }\n            membershipType {\n              id\n            }\n            memberGroups {\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      masquerader {\n        __typename\n        email\n        username\n        id\n      }\n      user {\n        __typename\n        id\n        email\n        username\n        ... on MemberUser {\n          memberProfiles(active: true) {\n            edges {\n              node {\n                member {\n                  __typename\n                  club {\n                    id\n                    name\n                    slug\n                    supportsPublic\n                    logoImage {\n                      publicId: renderingKey\n                    }\n                  }\n                  ... on Node {\n                    __isNode: __typename\n                    id\n                  }\n                }\n                id\n              }\n            }\n          }\n          metadata {\n            hasSeenNotificationNudgeModal\n          }\n        }\n      }\n    }\n    errors {\n      __typename\n      code\n      message\n      field\n    }\n  }\n}\n\nfragment useSyncAnalyticsTrackingPermission_session on Session {\n  allowUnauthenticatedAnalyticsTracking\n  requiresAnalyticsTrackingConsent\n  user {\n    __typename\n    ... on MemberUser {\n      metadata {\n        analyticsTrackingConsentedAt\n      }\n    }\n    id\n  }\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        defaultCountryCode\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cf1ded5cb9afee13afd6cb6fee499354";

export default node;
